// The current application coordinates were pre-registered in a B2C tenant.
export const apiConfig = {
  b2cScopes: ["https://dnatatravelukb2c.onmicrosoft.com/oneairadminapi/oneair.read"],
  webApi: "https://dnatatravelukb2c.onmicrosoft.com/oneairadminapi/oneair.write"
};